import { render, staticRenderFns } from "./DozenteneinsatzAdministrierenModal.vue?vue&type=template&id=3b66f8c4&"
import script from "./DozenteneinsatzAdministrierenModal.vue?vue&type=script&lang=js&"
export * from "./DozenteneinsatzAdministrierenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports